
































import { ExportApi } from '@/api/export';
import { Forbidden } from '@/api/responses/forbidden';
import layout from '@/layouts/app.vue';
import { PartnerPractice } from '@/shared/partner-practice';
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const partnerPracticesModule = namespace('partnerPractices');
const userModule = namespace('user');
const exportApi = new ExportApi();

@Component({
    components: {
        layout,
    },
})
export default class AdminExport extends Vue {
    @partnerPracticesModule.Getter('partnerPracticesForCurrentUser') private partnerPractices!: Array<PartnerPractice>;

    @userModule.Getter('isInternalKeyStakeholder') private isInternalKeyStakeholder!: boolean;

    private selectedExportDataType: number | null = null;
    private selectedPartnerPracticeId: string | null = null;

    private get exportItems(): Array<{}> {
        const items: Array<{}> = [
            { value: null, text: '--- Please Select ---' },
            { value: 0, text: 'Client Data' },
            { value: 1, text: 'Appointment Data' },
            { value: 2, text: 'Call Data' },
            { value: 3, text: 'Data Report' },
        ];

        if (this.isInternalKeyStakeholder) {
            items.push({ value: 4, text: 'Client Data for Cleansing' });
        }

        return items;
    }

    public async downloadAsync(): Promise<void> {
        const isValid = await this.$validator.validateAll();
        const isPartnerPracticeValid = await this.$validator.validateAll('partner-practice-select');

        if (!isValid || !isPartnerPracticeValid) {
            return;
        }

        try {
            let response = '';
            let filename = '';

            switch (this.selectedExportDataType) {
                case 0: {

                    response = await exportApi.getClientDataAsync(this.selectedPartnerPracticeId!);
                    filename = 'client-export.xlsx';
                    break;
                }
                case 1: {
                    response = await exportApi.getAppointmentDataAsync(this.selectedPartnerPracticeId!);
                    filename = 'appointment-export.xlsx';
                    break;
                }
                case 2: {
                    response = await exportApi.getCallDataAsync(this.selectedPartnerPracticeId!);
                    filename = 'call-export.xlsx';
                    break;
                }
                case 3: {
                    response = await exportApi.getDataReportAsync(this.selectedPartnerPracticeId!);
                    filename = 'data-export.xlsx';
                    break;
                }
                case 4: {
                    response = await exportApi.getDataCleanseExportAsync(this.selectedPartnerPracticeId!);
                    filename = 'data-cleanse-export.xlsx';
                }
            }

            const blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const link = document.createElement('a');
            link.rel = 'noopener';
            link.href = window.URL.createObjectURL(blob);
            link.download = filename;
            link.target = '_blank';
            link.click();
            window.URL.revokeObjectURL(link.href);
        } catch (e) {
            if (e instanceof Forbidden) {
                this.$router.push({ name: 'forbidden' });
            } else if (e instanceof Error) {
                this.$snackbar.open({ message: e.message, type: 'is-danger' });
            } else {
                this.$snackbar.open({ message: 'Could not download requested export data type, please try again.', type: 'is-danger' });
            }
        }
    }

    public async mounted(): Promise<void> {
        await this.$store.dispatch(`partnerPractices/loadPartnerPracticesAsync`);
    }
}
